import { Container, Grid, Paper, Button } from '@mui/material';
import CountUp from 'react-countup';
import styled from 'styled-components';
import Students from "../../assets/img1.png";
import Lessons from "../../assets/subjects.svg";
import { getClassStudents, getSubjectDetails } from '../../redux/sclassRelated/sclassHandle';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import SeeNotice from '../../components/SeeNotice';

const TeacherHomePage = () => {
    const dispatch = useDispatch();
    const { currentUser } = useSelector((state) => state.user);
    const { subjectDetails, sclassStudents } = useSelector((state) => state.sclass);

    const classID = currentUser.teachSclass?._id;
    const subjectID = currentUser.teachSubject?._id;

    useEffect(() => {
        dispatch(getSubjectDetails(subjectID, "Subject"));
        dispatch(getClassStudents(classID));
    }, [dispatch, subjectID, classID]);

    const numberOfStudents = sclassStudents && sclassStudents.length;
    const numberOfSessions = subjectDetails && subjectDetails.sessions;

    return (
        <>
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4, padding: { xs: 2, sm: 3 } }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <StyledPaper>
                            <img src={Students} alt="Students" style={{ width: '60px', height: '60px' }} />
                            <Title>Class Students</Title>
                            <Data start={0} end={numberOfStudents} duration={2.5} />
                            <StyledButton></StyledButton>
                        </StyledPaper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <StyledPaper>
                            <img src={Lessons} alt="Session" style={{ width: '60px', height: '60px' }} />
                            <Title>Total Lessons</Title>
                            <Data start={0} end={numberOfSessions} duration={5} />
                            <StyledButton></StyledButton>
                        </StyledPaper>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                        <SeeNotice />
                    </Paper>
                </Grid>
            </Container>
        </>
    );
};

const StyledPaper = styled(Paper)`
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 220px;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  background: linear-gradient(135deg, #008080, #FFD700);
  color: white;
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 600px) {
    height: 180px;
    padding: 12px;
  }
`;

const Title = styled.p`
  font-size: 1.4rem;
  font-weight: bold;
  color: #FFD700;

  @media (max-width: 600px) {
    font-size: 1.2rem;
  }
`;

const Data = styled(CountUp)`
  font-size: calc(1.3rem + .6vw);
  color: #fff;
  font-weight: bold;

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

const StyledButton = styled(Button)`
  background-color: #FFD700 !important;
  color: #008080 !important;
  font-weight: bold;
  margin-top: 8px;
  border-radius: 8px;
  padding: 8px 16px;
  transition: background 0.3s, transform 0.2s;

  &:hover {
    background-color: #ffcc00 !important;
    transform: scale(1.05);
  }

  @media (max-width: 600px) {
    padding: 6px 12px;
    font-size: 0.9rem;
  }
`;

export default TeacherHomePage;